import { render, staticRenderFns } from "./WidgetResourcePage.vue?vue&type=template&id=7db4d250&scoped=true&"
import script from "./WidgetResourcePage.vue?vue&type=script&lang=js&"
export * from "./WidgetResourcePage.vue?vue&type=script&lang=js&"
import style0 from "./WidgetResourcePage.vue?vue&type=style&index=0&id=7db4d250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db4d250",
  null
  
)

export default component.exports